import { AlertTriangle } from 'lucide-react'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { cn } from '@/utils/cn'
import type { CommitmentLetterPrepareResponse } from '@/api/commitmentLetters'

interface PrepareIssuesProps {
  data: CommitmentLetterPrepareResponse
  className?: string
}

/** Plan setup problems from /prepare (missing vendor, missing calendar, ...). */
export function PrepareIssues({ data, className }: PrepareIssuesProps) {
  if (data.line_items_without_vendor.length === 0 && data.warnings.length === 0)
    return null

  return (
    <div className={cn('flex flex-col gap-3', className)}>
      {data.line_items_without_vendor.length > 0 && (
        <Alert variant="destructive">
          <AlertTriangle className="h-4 w-4" />
          <AlertTitle>Line items without vendor</AlertTitle>
          <AlertDescription>
            {data.line_items_without_vendor.length} selected line item(s) have
            no vendor. Assign a vendor or deselect them to continue.
          </AlertDescription>
        </Alert>
      )}

      {data.warnings.map(warning => (
        <Alert key={warning} variant="warning">
          <AlertTriangle className="h-4 w-4" />
          <AlertDescription>{warning}</AlertDescription>
        </Alert>
      ))}
    </div>
  )
}
